import { App } from '../App';
import { UI } from '../UI';

import './scss/distChannels.scss';

export const DistributionChannels = (function () {
  let dialog = ({ data = {}, accountId = '', ok = () => {}, close = () => {}, init = () => {} }) => {
    UI.blockPage();
    accountId = accountId ? accountId : window['DT'].currenteditedcontent.accountId;
    $.when(App.ajaxData(`store/list/${accountId}`, {})).done((res) => {
      data = {
        element: res.data,
        $lang: $lang
      };
      let template = require('./tmpl/distChannels.hbs');
      bootbox
        .dialog({
          title: $lang.artwork.EditDistributionChannels,
          message: template(data),
          size: 'xl',
          className: 'modal-scrolled-content modal-editTerritories',
          onEscape: close,
          buttons: {
            Ok: {
              label: `<i class="fal fa-save"></i> ${$lang.btn.save}`,
              className: 'btn btn-primary',
              callback: ok
            },
            Close: {
              label: `<i class="fal fa-times"></i> ${$lang.btn.cancel}`,
              className: 'btn btn-default',
              callback: close
            }
          }
        })
        .init(init);
      UI.unblockPage();
    });
  };

  return {
    dialog
  };
})();
